export default {"src":"/_next/static/media/easier-2.82ab9949.svg","height":55,"width":55};